import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  propertyType: [],
  propertySubtype: [],
  constructionType: [],
  areaUnit: [],
  propertyUnitType: [],
  propertySubtypeMapping: {},
  projectData: [],
  projectId: "",
  residentUnitData: [],
  isLoad: false,
};

const ProjectSlice = createSlice({
  name: "Project",
  initialState,
  reducers: {
    setLoad(state, action) {
      state.isLoad = action.payload;
    },
    saveProjectId(state, action) {
      state.projectId = action.payload;
    },
    saveResidentUnitData(state, action) {
      state.residentUnitData = action.payload;
    },
    saveProject(state, action) {
      state.projectData = action.payload;
    },
    setPropertyType(state, action) {
      state.propertyType = action.payload;
    },
    setPropertySubtype(state, action) {
      state.propertySubtype = action.payload;
    },
    setConstructionType(state, action) {
      state.constructionType = action.payload;
    },
    setAreaUnit(state, action) {
      state.areaUnit = action.payload;
    },
    setPropertyUnitType(state, action) {
      state.propertyUnitType = action.payload;
    },
    setPropertySubtypeMapping(state, action) {
      state.propertySubtypeMapping = action.payload;
    },
  },
});

export const {
  setPropertyType,
  setLoad,
  setPropertySubtype,
  setConstructionType,
  setAreaUnit,
  setPropertyUnitType,
  setPropertySubtypeMapping,
  saveProject,
  saveProjectId,
  saveResidentUnitData,
} = ProjectSlice.actions;

export default ProjectSlice.reducer;
